import React, { useState } from 'react';
import { withTheme } from 'styled-components';
import { compose } from 'recompose';
import GetPromo from './gql/get-promo.js';
import DeletePromo from '../gql/mutations/delete-promo';
import Container from 'components/Container';
import Icon from 'components/Icon';
import PromoEdit from '../PromosEdit';
import { toast } from 'react-toastify';

import {
  CardText,
  CardLabel,
  CardContent,
  Card
} from 'components/Card/cardStyle';

const Promos = props => {
  const [isVisible, setIsVisible] = useState(false);
  const [newPromo, setNewPromo] = useState(false);
  const [editPromo, setEditPromo] = useState(null);
  const [showModal, setShowModal] = useState(false);

  let adminTrack = window.location.pathname.indexOf('/admin-track');

  const handleOutClick = () => {
    setEditPromo(null);
    setShowModal(false);
    setNewPromo(false);

    setTimeout(() => {
      setIsVisible(!isVisible);
    }, 300);
  };

  if (!props.data.getPromo) return false;

  return props.data.loading ? (
    <div />
  ) : (
    <Container>
      <div style={{ padding: 20 }}>
        <Card key={props.data.getPromo.id}>
          {adminTrack === 0 ? null : (
            <CardText>
              <CardLabel style={{ width: '40%' }}>Issuer: </CardLabel>
              <CardContent style={{ width: '60%' }}>
                {props.data.getPromo.issuer || 'Admin'}
              </CardContent>
            </CardText>
          )}
          <CardText>
            <CardLabel style={{ width: '40%' }}>Code Name: </CardLabel>
            <CardContent style={{ width: '60%' }}>
              {props.data.getPromo.name}
            </CardContent>
          </CardText>
          <CardText>
            <CardLabel style={{ width: '40%' }}>Expiration: </CardLabel>
            <CardContent style={{ width: '60%' }}>
              {props.data.getPromo.expiration
                ? props.data.getPromo.expiration
                : 'None'}
            </CardContent>
          </CardText>
          <CardText>
            <CardLabel style={{ width: '40%' }}>Pass Disc. %: </CardLabel>
            <CardContent style={{ width: '60%' }}>
              {`${props.data.getPromo.ticket_discount}%` || 0}
            </CardContent>
          </CardText>
          <CardText>
            <CardLabel style={{ width: '40%' }}>Fee Disc. %: </CardLabel>
            <CardContent style={{ width: '60%' }}>
              {`${props.data.getPromo.service_discount}%` || 0}
            </CardContent>
          </CardText>
          <CardText>
            <CardLabel style={{ width: '40%' }}>Use Limit: </CardLabel>
            <CardContent style={{ width: '60%' }}>
              {props.data.getPromo.limit || 0}
            </CardContent>
          </CardText>
          <Icon
            icon="edit"
            size={23}
            color={props.theme.colors.primary}
            padding="0 15px 0 0"
            onClick={async () => {
              setEditPromo(props.data.getPromo.id);
              setIsVisible(true);
              setTimeout(() => {
                setShowModal(true);
              }, 300);
            }}
          />
          <Icon
            icon="trash"
            size={23}
            color={props.theme.colors.primary}
            onClick={async () => {
              const successMessage = () =>
                toast.success('Promo Successfully Deleted');
              const errorMessage = () => toast.error('Error Deleting Promo');

              if (
                window.confirm('Are you sure you want to delete this promo?')
              ) {
                const response = await props.deletePromo({
                  id: props.data.getPromo.id
                });

                if (!response || response.errors) {
                  errorMessage();
                }
                successMessage();

                props.history.push(props.match.url.replace(/[0-9]/g, ''));
              }
            }}
          />
        </Card>
      </div>
      <PromoEdit
        newPromo={newPromo}
        isVisible={showModal}
        handleOutClick={handleOutClick}
        currentPromo={editPromo}
      />
    </Container>
  );
};

export default compose(GetPromo, DeletePromo)(withTheme(Promos));
